export const blockIconsAudioandvideoQueueMusicNew = (
	<span className='material-symbols-outlined'>queue_music</span>
);
